import { Col, Modal, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { Spinner } from 'components/shared/loader/Spinner';
import { Fade } from 'react-awesome-reveal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  areas,
  CUSTOMER_TYPE,
  CV_VIEW_NAME,
  NOT_AVAILABLE,
  NULL_STRING,
  PRIORITY_ADD_SUCCESS_MSG,
  HTTP_UNPROCESSABLE_ENTITY,
  NOT_APPLICABLE,
  CUSTOMER_TYPE_ENTITY,
  CUSTOMER_TYPE_FLAG,
  INSIGHT_TYPE,
  NUMBER_ZERO,
  EMPTY_ARRAY,
  QUERY_KEY,
} from 'constants/constants';
import McoCustomerKPI from './McoCustomerKPI';
import McoGaugeChart from './McoGaugeChart';
import Contacts from 'components/customer/banner/Contacts';
import { useEffect, useState } from 'react';
import LinkButton from 'components/shared/button/LinkButton';
import { Switch } from 'antd';

import classes from './McoBanner.module.scss';
import {
  addMemberToTeam,
  deleteAccount,
} from 'services/configure-priority.service';
import {
  setFocusAccountChecked,
  setFocusAccountDisabled,
  setPriorityCustomers,
  setSeletedView,
  setSelectedCustomer,
  setInsightType,
  setFilterInit,
  setSelectedInsightView,
  setAllInsightView,
} from 'store/customer/customerViewSlice';
import {
  getCustomerContacts,
  getPayerPieData,
} from 'store/customer/customer-view-actions';
import { toast } from 'react-toastify';
import { capitalize } from 'lodash';
import { isKeysAreNull } from 'utils/utils';
import { useQuery } from '@tanstack/react-query';
import { useCustomerDetails } from './Banner.hooks';

const McoCustomerInfo = () => {
  const focussedAccount = useSelector(
    (state) => state?.CustomerView?.focusAccountChecked
  );
  const contacts = useSelector((state) => state?.CustomerView?.contacts);
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );
  const hasContacts = contacts?.length > 0;
  const [show, setShow] = useState(false);
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const [checkedSwitch, setCheckedSwitch] = useState(focussedAccount);
  const [loading, setLoading] = useState(false);
  const priorityCustomers = useSelector(
    (state) => state?.CustomerView?.priorityCustomers
  );

  const isPayer =
    selectedCustomer?.flag ===
    CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)[NUMBER_ZERO];

  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);

  useEffect(() => {
    dispatch(getCustomerContacts(selectedCustomer?.value));
  }, [selectedCustomer]);

  // fetch MCO customer details using react query
  const { data: mcoCustomer } = useQuery({
    queryKey: [QUERY_KEY.PayerPieMCOData, selectedCustomer?.value],
    queryFn: async () => {
      const response = await getPayerPieData(
        selectedCustomer?.value,
        selectedCustomer?.flag,
        roleId,
        CV_VIEW_NAME.MCO
      );
      return response?.values?.[NUMBER_ZERO];
    },

    enabled: !!selectedCustomer?.value,
  });

  // fetch MCO customer details using react query
  const { data: customerDetails, isLoading: isCustomerLoading } =
    useCustomerDetails(selectedCustomer);

  useEffect(() => {
    const checkPriority =
      contacts?.length > 0
        ? contacts?.some(
            (item) => item?.unixId === unixId && item.roleCode === roleId
          )
        : false;

    setCheckedSwitch(checkPriority);

    dispatch(setFocusAccountChecked(checkPriority));
  }, [contacts]);

  const handleClickAffiliatedTo = () => {
    if (
      customerDetails?.affilatedTo &&
      customerDetails?.affilatedTo?.mdmId &&
      customerDetails?.affilatedTo?.name
    ) {
      const payload = {
        value: customerDetails?.affilatedTo?.mdmId,
        label: customerDetails?.affilatedTo?.name,
        flag: CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PARENTPAYER)[
          NUMBER_ZERO
        ],
      };
      dispatch(setFilterInit());
      dispatch(setSeletedView(CUSTOMER_TYPE_ENTITY.PARENTPAYER));
      dispatch(setSelectedCustomer(payload));
      dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
      dispatch(setSelectedInsightView(EMPTY_ARRAY));
      dispatch(setAllInsightView(EMPTY_ARRAY));
      navigation(`/customerView/list/${customerDetails?.affilatedTo?.name}`);
    }
  };

  const dispatch = useDispatch();
  const navigation = useNavigate();

  const onToggleChange = async (checked) => {
    setLoading(true);
    try {
      if (checked) {
        const payload = {
          unixId: unixId,
          customerId: selectedCustomer?.value,
          primaryFlag: 'N',
          squad: null,
          roleId,
          // MCO : Irespective of ecosystem user can set priority customer
        };

        const response = await addMemberToTeam(payload);

        if (response?.error?.code === HTTP_UNPROCESSABLE_ENTITY) {
          toast.error(`${response?.message}`);
        } else if (response.result) {
          dispatch(
            setPriorityCustomers([...priorityCustomers, selectedCustomer])
          );
          dispatch(getCustomerContacts(selectedCustomer?.value));
          setCheckedSwitch(true);
          dispatch(setFocusAccountChecked(true));
          dispatch(setFocusAccountDisabled(false));
          toast.success(
            `${selectedCustomer?.label} ${PRIORITY_ADD_SUCCESS_MSG}`
          );
        }
      } else {
        const response = await deleteAccount(
          selectedCustomer?.value,
          unixId,
          roleId
        );
        if (response.error) {
          throw new Error(response.error);
        }

        dispatch(getCustomerContacts(selectedCustomer?.value));
        setCheckedSwitch(false);
        dispatch(setFocusAccountChecked(false));
        const filterpriorityCustomers = priorityCustomers.filter(
          (focusAccount) => focusAccount.value !== selectedCustomer?.value
        );
        dispatch(setPriorityCustomers(filterpriorityCustomers));
        dispatch(
          setFocusAccountDisabled(!(filterpriorityCustomers.length > 0))
        );
        toast.success(
          `${selectedCustomer?.label}  has been successfully removed as your priority  ${selectedView}.`
        );
      }
    } catch (error) {
      toast.error('Operation failed.');
      setCheckedSwitch(!checked);
    } finally {
      setLoading(false);
    }
  };

  const feedbackTooltip = (
    <Popover className='p-2'>
      In case any policy related data may be incorrect, please use this link to
      submit a data change request.
    </Popover>
  );

  return (
    <div>
      <Row>
        <Col
          md={12}
          className='ps-0'>
          <Fade>
            <p className='title__bold title__x-large title__capitalize mb-0'>
              {!selectedCustomer?.label ? (
                <span className='title__x-large'>{NULL_STRING}</span>
              ) : selectedCustomer?.label?.length > 50 ? (
                <OverlayTrigger
                  overlay={
                    <Popover className='p-2'>{selectedCustomer?.label}</Popover>
                  }
                  placement='top'>
                  <p className='title__bold title__x-large title__capitalize mb-0'>
                    {selectedCustomer?.label?.length > 50
                      ? `${selectedCustomer?.label
                          ?.toLowerCase()
                          .substring(0, 50)}...`
                      : selectedCustomer?.label?.toLowerCase()}
                  </p>
                </OverlayTrigger>
              ) : (
                <>{selectedCustomer?.label?.toLowerCase()}</>
              )}
            </p>
            <div className='d-flex align-items-center'>
              <span className='text text__capitalize me-3'>
                {capitalize(CUSTOMER_TYPE.get(selectedCustomer?.flag))}
              </span>
              {selectedCustomer?.flag ===
                CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.[
                  NUMBER_ZERO
                ] && (
                <OverlayTrigger
                  overlay={feedbackTooltip}
                  placement='auto'>
                  <span className='text__x-small text__bold mt-1'>
                    <i className='icon icon__external small' />
                    <a
                      target='_blank'
                      rel='noreferrer'
                      className={classes['policy-feedback-link']}
                      href={`${process.env.REACT_APP_POLICY_FEEDBACK_UPDATE_URL}&mdm_payer_id=${selectedCustomer?.value}`}>
                      Policy Intelligence Update Form
                    </a>
                  </span>
                </OverlayTrigger>
              )}
            </div>
          </Fade>
        </Col>
      </Row>
      <Row>
        <Col
          md={3}
          xxl={3}
          className='ps-0 pt-2'>
          <Fade cascade>
            <p className='title__bold title__x-small mb-1 '>Address</p>
            {isCustomerLoading ? (
              <Spinner area={areas.bannerSegment} />
            ) : (
              <div>
                {!isKeysAreNull(customerDetails, [
                  'address1',
                  'state',
                  'city',
                  'zip',
                ]) ? (
                  <p className='title__x-small'>
                    {customerDetails?.address1} &nbsp;
                    {customerDetails?.city}
                    {customerDetails?.state || customerDetails?.zip
                      ? ', '
                      : ' '}
                    {customerDetails?.state} {customerDetails?.zip}
                  </p>
                ) : (
                  <span className='text text__x-small'>{NOT_AVAILABLE}</span>
                )}
              </div>
            )}
          </Fade>
        </Col>
        {isPayer ? (
          <Col
            md={2}
            xxl={2}
            className='pe-0 ps-0 pt-2'>
            <Fade>
              <p className='title__bold title__x-small mb-1'>Affiliated to</p>
              {isCustomerLoading ? (
                <Spinner area={areas.bannerSegment} />
              ) : customerDetails?.affilatedTo &&
                customerDetails?.affilatedTo?.name ? (
                <OverlayTrigger
                  overlay={
                    <Popover className='p-2'>
                      {customerDetails?.affilatedTo?.name}
                    </Popover>
                  }
                  placement='bottom'>
                  <span
                    onClick={() => handleClickAffiliatedTo()}
                    className={`${classes['payer-affiliated-to']} ${classes['truncate-text']} span-link affiliated-link`}>
                    {customerDetails?.affilatedTo?.name}
                  </span>
                </OverlayTrigger>
              ) : (
                <span className={`${classes['payer-affiliated-to']}`}>
                  {NOT_APPLICABLE}
                </span>
              )}
            </Fade>
          </Col>
        ) : null}
        <Col
          md={isPayer ? 3 : 4}
          xxl={isPayer ? 3 : 4}>
          <Fade>
            <Spinner area={areas.bannerSegment} />
            <McoCustomerKPI
              customerDetails={mcoCustomer}
              selectedCustomer={selectedCustomer}
            />
          </Fade>
        </Col>
        <Col
          md={isPayer ? 4 : 5}
          xxl={isPayer ? 4 : 5}
          className={`${classes['lives-covered-section']} ps-0`}>
          <Fade>
            {mcoCustomer?.livesCoveredByBenefitType ? (
              <McoGaugeChart customerDetails={mcoCustomer} />
            ) : (
              <Fade>
                <p className='text-center'>{NULL_STRING}</p>
                <Spinner area={areas.bannerSegment} />
              </Fade>
            )}
          </Fade>
        </Col>
      </Row>
      <Row>
        <Fade className='ps-0'>
          <div className='d-flex align-items-center mb-3'>
            <p className='title__bold me-4 mb-0 animate__animated animate__fadeIn'>
              Genentech Point of Contact
            </p>

            {hasContacts && (
              <LinkButton
                className={classes['link-cta']}
                onClick={() => setShow(true)}>
                <i className='icon icon__external'></i>
                View All
              </LinkButton>
            )}
            <Switch
              key={checkedSwitch}
              className='ms-3'
              checkedChildren={
                <i className={`m-0 icon icon__white_primarycontact`}></i>
              }
              checked={checkedSwitch}
              defaultChecked={focussedAccount}
              onChange={onToggleChange}
              size='small'
              loading={loading}
            />
            <OverlayTrigger
              overlay={
                <Popover className='p-2'>
                  Setting a customer as a priority designates you as a Point of
                  Contact (POC) for the customer, fostering collaboration with
                  the account team.
                </Popover>
              }
              placement='bottom'>
              <span
                className={`ms-2 text text__x-small text-decoration-underline`}>
                Set as Priority
              </span>
            </OverlayTrigger>
          </div>
        </Fade>
        <Fade className='ps-0'>
          <Contacts
            contacts={contacts}
            splitIndex={3}
            switch={checkedSwitch}
          />
        </Fade>
      </Row>
      {/* contact modal */}
      <Modal
        size='lg'
        className='title gne-modal contact'
        show={show}
        onHide={() => setShow(false)}>
        <Modal.Header
          className={`me-3`}
          closeButton>
          <Modal.Title>
            <p className='title__bold title__base animate__animated animate__fadeIn'>
              <i className='icon icon__user'></i>
              Genentech Point of Contact
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='overflow-y-auto'>
          <Contacts contacts={contacts} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default McoCustomerInfo;
